module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, _vm._l((_vm.registros), function(registro) {
    return (registro.controlador === 'Woodard' && registro.exibir) ? _c('li', {
      key: registro.key,
      staticClass: "dropdown messages-menu"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;",
        "data-toggle": "dropdown"
      }
    }, [_c('i', {
      class: registro.icone
    }), _vm._v(" "), _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(registro.valor))])]), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu"
    }, [_c('li', {
      staticClass: "header"
    }, [_c('h3', [_vm._v(_vm._s(registro.label) + ": " + _vm._s(registro.valor) + " " + _vm._s(registro.umedida))])]), _vm._v(" "), _c('li', {
      staticClass: "header"
    }, [_c('p', [_vm._v(_vm._s(registro.descricao))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(registro.data) + " - " + _vm._s(registro.hora))])]), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', {
      staticClass: "footer"
    }) : _vm._e()])]) : _vm._e()
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo-mini"
  }, [_c('a', {
    attrs: {
      "href": "http://www.archea-biogas.de/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    attrs: {
      "src": "/static/img/bi-logo-archea-biogas2.svg",
      "alt": "Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16e30b66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DashHeader.vue
// module id = 1542
// module chunks = 1